import type { SavedView, SavedViewState } from '@parcel/ui';

export const DRAFT_VIEW_ID = '__draft_saved_view__';
export const DRAFT_VIEW_NAME = 'Untitled view';

export function createDraftSavedView(state: SavedViewState): SavedView {
  const now = new Date().toISOString();

  return {
    id: DRAFT_VIEW_ID,
    name: DRAFT_VIEW_NAME,
    state,
    createdAt: now,
    updatedAt: now,
  };
}

export function isConfirmedViewName(name: string) {
  const trimmed = name.trim();
  return Boolean(trimmed) && trimmed !== DRAFT_VIEW_NAME;
}
